import { createAsyncThunk } from '@reduxjs/toolkit';
import { serializeError } from 'shared/utils/redux';
import { trendDataApi } from 'container/trendDataApi';

import { STORE_NAME } from './initialState';

export const fetchTrendDataList = createAsyncThunk(
  `${STORE_NAME}/fetchTrendDataList`,
  async ({ projectId }: { projectId: number }) => {
    return trendDataApi.list(projectId);
  },
  { serializeError },
);

export const deleteTrend = createAsyncThunk(
  `${STORE_NAME}/deleteTrend`,
  async ({ id }: { id: number }) => {
    return trendDataApi.delete(id).then(() => id);
  },
  { serializeError },
);

export const uploadTrendData = createAsyncThunk(
  `${STORE_NAME}/uploadTrendData`,
  async ({ projectId, file }: { projectId: number; file: File }, { rejectWithValue }) => {
    return trendDataApi.upload(file, projectId).catch(rejectWithValue);
  },
  { serializeError },
);
